import { DS_POPOVER_ARROW_SIDE, type DSPopoverArrowSide } from "@/src/design_system/primitives/popover/types/arrow";

export const DS_POPOVER_CLASSES = {
  Popover: "ds-popover",
  WithArrow: "ds-popover--with-arrow",
  Arrow: "ds-popover__arrow",
} as const;

export const DS_POPOVER_ARROW_SIDE_CLASS: Record<DSPopoverArrowSide, string> = {
  [DS_POPOVER_ARROW_SIDE.Top]: "ds-popover--arrow-top",
  [DS_POPOVER_ARROW_SIDE.Bottom]: "ds-popover--arrow-bottom",
  [DS_POPOVER_ARROW_SIDE.Left]: "ds-popover--arrow-left",
  [DS_POPOVER_ARROW_SIDE.Right]: "ds-popover--arrow-right",
};

/** Arrow position along the edge, px from the popover's top or left edge. */
export const DS_POPOVER_ARROW_OFFSET_VAR = "--ds-popover-arrow-offset";
